import useProject from '@hooks/useProject';
import SocialFacebookIcon from '@icons/social/SocialFacebookIcon';
import SocialHomepageIcon from '@icons/social/SocialHomepageIcon';
import SocialInstagramIcon from '@icons/social/SocialInstgramIcon';
import SocialNaverIcon from '@icons/social/SocialNaverIcon';
import SocialYoutubeIcon from '@icons/social/SocialYoutubeIcon';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function OfficialChannels() {
    const project = useProject();
    const officialChannel = project?.officialChannel;
    const { t } = useTranslation('main', { keyPrefix: 'sidebar.officialChannels' });
    if (officialChannel && project?.features.officialChannelEnabled) {
        const {
            homeUrl, instagramUrl, facebookUrl, youtubeUrl, naverBlogUrl,
        } = officialChannel;
        return (
            <LinkContainer title={t('title')}>
                {homeUrl && (
                    <LinkRow label={t('homePage')}
                        icon={SocialHomepageIcon}
                        externalLink={homeUrl} />
                )}
                {youtubeUrl && (
                    <LinkRow label={t('youtube')}
                        icon={SocialYoutubeIcon}
                        externalLink={youtubeUrl} />
                )}
                {instagramUrl && (
                    <LinkRow label={t('instagram')}
                        icon={SocialInstagramIcon}
                        externalLink={instagramUrl} />
                )}
                {naverBlogUrl && (
                    <LinkRow label={t('naverBlog')}
                        icon={SocialNaverIcon}
                        externalLink={naverBlogUrl} />
                )}
                {facebookUrl && (
                    <LinkRow label={t('facebook')}
                        icon={SocialFacebookIcon}
                        externalLink={facebookUrl} />
                )}

            </LinkContainer>
        );
    }
    return (<Fragment/>);
}

export default OfficialChannels;
